import { create } from "zustand";
import api from "@/api/client";

export const useAuthStore = create((set, get) => ({
  user: undefined, // undefined = loading, null = unauthenticated, object = authenticated
  org: null,

  setSession: (data) => {
    if (data?.access_token) localStorage.setItem("access_token", data.access_token);
    if (data?.refresh_token) localStorage.setItem("refresh_token", data.refresh_token);
    set({ user: data?.user || null });
  },

  login: async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    get().setSession(data);
    return data.user;
  },

  register: async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    get().setSession(data);
    return data.user;
  },

  logout: async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    set({ user: null, org: null });
  },

  loadMe: async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      set({ user: null });
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      set({ user: data });
    } catch {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      set({ user: null });
    }
  },

  updateProfile: async (payload) => {
    const { data } = await api.put("/auth/me", payload);
    set({ user: data });
    return data;
  },
}));
